module.exports = __webpack_public_path__ + "img/banner3.15e5d970.jpg";